import { toast } from "sonner";
import { Share2 } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function ShareButton({ slug, title, excerpt }) {
  const shareUrl = `${BACKEND}/api/share/journal/${slug}`;

  const share = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title, text: excerpt, url: shareUrl });
        return;
      } catch (e) {
        if (e.name === "AbortError") return;
      }
    }
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success("Share link copied — paste it anywhere for a rich preview");
    } catch {
      window.prompt("Copy this share link", shareUrl);
    }
  };

  return (
    <button
      type="button"
      data-testid="story-share-button"
      onClick={share}
      className="inline-flex items-center gap-2 border border-champagne/40 px-5 py-2.5 text-[10px] font-mono tracking-[0.25em] uppercase text-champagne hover:bg-champagne hover:text-obsidian transition-colors duration-300"
    >
      <Share2 size={13} /> Share
    </button>
  );
}
